"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleType = exports.RolePermissionTypes = exports.ApplicationKeys = exports.RestMethodKeys = void 0;
var RestMethodKeys;
(function (RestMethodKeys) {
    RestMethodKeys["Count"] = "count";
    RestMethodKeys["Create"] = "create";
    RestMethodKeys["Delete"] = "delete";
    RestMethodKeys["Find"] = "find";
    RestMethodKeys["Findone"] = "findone";
    RestMethodKeys["Update"] = "update";
})(RestMethodKeys = exports.RestMethodKeys || (exports.RestMethodKeys = {}));
var ApplicationKeys;
(function (ApplicationKeys) {
    ApplicationKeys["Author"] = "author";
    ApplicationKeys["Benefit"] = "benefit";
    ApplicationKeys["Branch"] = "branch";
    ApplicationKeys["CompanyLocation"] = "company-location";
    ApplicationKeys["Homepage"] = "homepage";
    ApplicationKeys["Job"] = "job";
    ApplicationKeys["Page"] = "page";
    ApplicationKeys["Service"] = "service";
    ApplicationKeys["Social"] = "social";
})(ApplicationKeys = exports.ApplicationKeys || (exports.ApplicationKeys = {}));
var RolePermissionTypes;
(function (RolePermissionTypes) {
    RolePermissionTypes["Application"] = "application";
    RolePermissionTypes["ContentManager"] = "content-manager";
    RolePermissionTypes["ContentTypeBuilder"] = "content-type-builder";
    RolePermissionTypes["Documentation"] = "documentation";
    RolePermissionTypes["Email"] = "email";
    RolePermissionTypes["Upload"] = "upload";
    RolePermissionTypes["UsersPermissions"] = "users-permissions";
})(RolePermissionTypes = exports.RolePermissionTypes || (exports.RolePermissionTypes = {}));
var RoleType;
(function (RoleType) {
    RoleType["Admin"] = "admin";
    RoleType["Authenticated"] = "authenticated";
    RoleType["Editor"] = "editor";
    RoleType["Public"] = "public";
})(RoleType = exports.RoleType || (exports.RoleType = {}));
